import { render, staticRenderFns } from "./todosDocumentos.vue?vue&type=template&id=5879e98c&scoped=true"
import script from "./todosDocumentos.ts?vue&type=script&lang=ts&external"
export * from "./todosDocumentos.ts?vue&type=script&lang=ts&external"
import style0 from "./todosDocumentos.vue?vue&type=style&index=0&id=5879e98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879e98c",
  null
  
)

export default component.exports